import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  CloseButton,
  Spinner,
  Row,
  Col,
  Form
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import UserContext from 'app/context/UserContext';
import { create, update } from 'app/api/costImpression';
import axios from 'axios';

const ModalUpload = ({
  showModal,
  handlerShowModal,
  updateTable,
  taskToEdit
}) => {
  const [loading, setLoading] = useState(false);
  const [noOfCost, setNoOfCost] = useState('');
  const [impressions, setImpressions] = useState('');
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (taskToEdit) {
      setNoOfCost(taskToEdit.noOfCost || '');
      setImpressions(taskToEdit.impressions || '');
    }
  }, [taskToEdit]);

  async function handlerSave() {
    setLoading(true);
    try {
      const formData = {
        noOfCost: Number(noOfCost),
        impressions: Number(impressions)
      };

      const response = taskToEdit
        ? await axios.request(update(user.token, taskToEdit.id, formData))
        : await axios.request(create(user.token, formData));

      if (response.data.success) {
        updateTable();
        toast.success(response.data.message || 'Success', { theme: 'colored' });
        handlerShowingModal();
      } else {
        toast.error(response.data.message || 'Operation failed.');
      }
    } catch (error) {
      toast.error('An error occurred.');
    } finally {
      setLoading(false);
    }
  }

  function handlerShowingModal() {
    setNoOfCost('');
    setImpressions('');
    handlerShowModal();
  }

  return (
    <Modal show={showModal} onHide={handlerShowingModal} size="md" centered>
      <Modal.Header>
        <Modal.Title>
          {taskToEdit ? 'Edit Impression' : 'Add Impression'}
        </Modal.Title>
        <CloseButton onClick={handlerShowingModal} />
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Cost</Form.Label>
          <Form.Control
            type="number"
            placeholder="Enter cost"
            value={noOfCost}
            onChange={e => setNoOfCost(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Impressions</Form.Label>
          <Form.Control
            type="number"
            placeholder='Enter impression in "k", eg: 1000 = 1k'
            value={impressions}
            onChange={e => setImpressions(e.target.value)}
          />
        </Form.Group>

        {!loading ? (
          <Row>
            <Col>
              <Button onClick={handlerSave} variant="success">
                {taskToEdit ? 'Update' : 'Save'}
              </Button>
            </Col>
            <Col className="d-flex justify-content-end">
              <Button onClick={handlerShowingModal} variant="outline-primary">
                Close
              </Button>
            </Col>
          </Row>
        ) : (
          <Button variant="primary" disabled>
            <Spinner as="span" animation="border" size="sm" /> Loading...
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

ModalUpload.propTypes = {
  showModal: PropTypes.bool,
  handlerShowModal: PropTypes.func,
  updateTable: PropTypes.func,
  taskToEdit: PropTypes.object
};

export default ModalUpload;
